module.exports = __webpack_public_path__ + "img/singlang-2019-2.d95ab6bd.png";